<template>
  <div>
    <div class="form-wrapper">
      <div class="form-group">
        <label>Select a service</label>
        <select class="form-select" v-model="model.service">
          <option
            v-for="service in allowedSlaServices"
            :key="service.key"
            :value="service.campaign"
          >{{ service.name }}</option>
        </select>
      </div>

      <div class="form-group" v-if="model.service === 'sandbox'">
        <label>Enter your phone number</label>
        <div class="input-wrapper">
          <input type="number" v-model.trim="model.phone" placeholder="966000000000" autofocus />
        </div>
      </div>
      <div class="submit-group">
        <button
          :disabled="loading || !model.service"
          @click="getSlaUrl()"
          class="btn btn-blue"
        >
          Subscribe
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store';
import Vue from 'vue';
import { mapState } from 'vuex';

export default {
  name: 'SubscriptionPaymentSla',
  async beforeRouteEnter(to, from, next) {
    if (store.state.payment.period === 'yearly') {
      const confirm = await Vue.swal({
        title: 'Unsupported period',
        text: 'SMS subscription has only monthly based period. If you need yearly subscription, please select the other method of payment. Switch to monthly period and continue?',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      });

      if (confirm.value) {
        store.commit('payment/setPeriod', 'monthly');
        Vue.toasted.show('Switched to monthly period');
        next();
      }
    } else {
      next();
    }
  },
  data: () => ({
    currentStep: 1,
    loading: false,
    model: {
      service: null,
      phone: null,
      pin: null,
    },
    isOoredooShamel: false,
  }),
  watch: {
    model: {
      handler() {
        this.$store.commit('payment/setError', null);
      },
      deep: true,
    },
  },
  computed: {
    ...mapState('payment', ['allowedSlaServices', 'allowedSlaSandbox']),
  },
  methods: {
    async getSlaUrl() {
      this.loading = true;
      const payload = {
        service: this.model.service,
        ...(this.allowedSlaSandbox && { msisdn: this.model.phone }),
      };

      try {
        console.log(payload);
        const { data: { result } } = await this.$store.dispatch('payment/getSlaPaymentUrl', payload);
        window.open(result, '_self');
      } catch (e) {
        this.$toasted.error(e, { duration: 5000 });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="less">

</style>
